if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.slider = this.querySelector('.product-media-modal__slider');
      }

      connectedCallback() {
        super.connectedCallback();
        this.initSlider();
      }

      disconnectedCallback() {
        if (this.sliderId && window.destroySlider) {
          window.destroySlider(this.sliderId);
          this.sliderId = null;
        }
      }

      initSlider() {
        if (!this.slider || this.sliderId) return;
        this.sliderId = window.initSlider(this.slider, {
          slidesPerView: 1,
          slidesPerGroup: 1,
          spaceBetween: 0,
          freeMode: false,
          loop: false,
          autoplay: false,
          navigation: true,
          keyboard: {
            enabled: true,
            onlyInViewport: false,
          },
          pagination: {
            clickable: true,
            el: '.swiper-pagination',
            dynamicBullets: true,
            dynamicMainBullets: 5,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        });
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const id = this.openedBy.getAttribute('data-media-id');

        const indexSlider = Array.from(this.slider.querySelectorAll(`[data-media-id]`)).findIndex(
          (element) => element.getAttribute('data-media-id') === id
        );

        if (this.sliderId && indexSlider >= 0) {
          const slider = window.getSwiperSlider(this.slider);
          if (slider) slider.slideTo(indexSlider);
        }

        this.querySelectorAll(`[data-media-id="${id}"]`).forEach((activeMedia) => {
          const activeMediaTemplate = activeMedia.querySelector('template');
          const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
          activeMedia.classList.add('active');
          if (
            activeMedia.nodeName == 'DEFERRED-MEDIA' &&
            activeMediaContent &&
            activeMediaContent.querySelector('.js-youtube')
          ) {
            activeMedia.loadContent();
          }
        });
      }
    }
  );
}
